<template>
  <v-card>
    <v-toolbar flat dense class="card-bar">
      <v-toolbar-title>Queues</v-toolbar-title>
      <v-btn icon small class="ml-2" @click="reload">
        <v-icon>refresh</v-icon>
      </v-btn>
      <!-- <v-btn icon small class="ml-2" @click="restartWorkers">
        <v-icon>mdi-play-circle</v-icon>
      </v-btn> -->
      <v-spacer />
      <OHoldToConfirm
        color="orange"
        :height="32"
        :progressSize="20"
        label="Restart"
      />
    </v-toolbar>

    <QueueDetailsDialog ref="queueDialog" />

    <OLoadingLine absolute :value="isLoading" />

    <ODataTable
      class="dense-table"
      :spec="spec"
      :items="rows"
      @rowClicked="showDialog"
    />

    <OAlert error v-if="err != null">{{ err }}</OAlert>
  </v-card>
</template>

<script>
import _ from 'lodash'
import OLoadingLine from 'oderon-vue/cpts/OLoadingLine'
import ODataTable from 'oderon-vue/cpts/ODataTable'
import { atMost } from 'oderon-commons/src/utils'
import UnpauserStore from './UnpauserStore'
import QueueDetailsDialog from '@/views/health/queues/QueueDetailsDialog'
import OHoldToConfirm from 'oderon-vue/cpts/OHoldToConfirm.vue'

export default {
  components: {
    OLoadingLine,
    ODataTable,
    QueueDetailsDialog,
    OHoldToConfirm
  },
  props: {
    client: {}
  },
  data() {
    return {
      spec: [
        { t: 'Queue name', d: 'queue.name' },
        {
          t: 'Worker state|',
          d: (r) => {
            if (r.worker == null) return 'missing'
            if (r.worker.state == 'stopped') {
              let lastErr = _.get(r, 'worker.lastWorkerError.message')
              return atMost('stopped: ' + (lastErr || '(no error msg)'), 40)
            } else {
              return r.worker.state
            }
          }
        },
        {
          t: 'Act─Wait|',
          d: (r) => `${r.queue.active || 0} ─ ${r.queue.waiting || 0}`
        }
      ]
    }
  },
  computed: {
    isLoading() {
      return UnpauserStore.queues.isLoading
    },
    rows() {
      return UnpauserStore.queues.rows
    },
    err() {
      return UnpauserStore.queues.err
    }
  },

  methods: {
    reload() {
      UnpauserStore.fetchQueues()
    },

    restartWorkers() {
      UnpauserStore.restartWorkers()
    },

    async showDialog(row) {
      let dialog = this.$refs.queueDialog,
        res = await dialog.open(row.queue.name)

      if (res != null) {
        if (res === 'FLUSH') {
          UnpauserStore.flushQueue(row.queue.name)
        } else if (res != null) {
          // res = {orgCode, clientId, extraInfo}
          UnpauserStore.restartWorker(res)
        }
      }
    }
  }
}
</script>

<style></style>
